import actionTypes from '../constants/action-types';

const resetGlobal = (globalElement) => ({
  type: actionTypes.RESET_GLOBAL,
  payload: {
    globalElement,
  },
});

export default resetGlobal;
